__turbopack_context__.v({
  "className": "kaushan_script_b2c49616-module__yLNJ4G__className",
});
